import { Insurability } from "model/insurability.model";
import { TarificationSessionKey } from "model/tarification-session-key.model";
import { ETarResult } from "model/e-tar.result";
import { Attestation } from "model/attestion.model";
import { History } from "history";
import { TarificationApplicationSession } from "model/tarification.model";

/** ---- Dispatch Types ---- */
export const LOAD_INSURABILITY_SUCCESS = "LOAD_INSURABILITY_SUCCESS";

export const TARIFICATION_SESSION_APP_START = "TARIFICATION_SESSION_APP_START";
export const TARIFICATION_SESSION_APP_ERROR = "TARIFICATION_SESSION_APP_ERROR";
export const TARIFICATION_SESSION_APP_SUCCESS =
  "TARIFICATION_SESSION_APP_SUCCESS";

export const TARIFICATION_SESSION_START = "TARIFICATION_SESSION_START";
export const TARIFICATION_SESSION_ERROR = "TARIFICATION_SESSION_ERROR";
export const TARIFICATION_SESSION_SUCCESS = "TARIFICATION_SESSION_SUCCESS";
export const TARIFICATION_SESSION_DETAILS_SUCCESS =
  "TARIFICATION_SESSION_DETAILS_SUCCESS";

export const TARIFICATION_ETAR_START = "TARIFICATION_ETAR_START";
export const TARIFICATION_ETAR_ERROR = "TARIFICATION_ETAR_ERROR";
export const TARIFICATION_ETAR_SUCCESS = "TARIFICATION_ETAR_SUCCESS";

export const DELETE_TARIFIED_ITEM_START = "DELETE_TARIFIED_ITEM_START";
export const DELETE_TARIFIED_ITEM_ERROR = "DELETE_TARIFIED_ITEM_ERROR";
export const DELETE_TARIFIED_ITEM_SUCCESS = "DELETE_TARIFIED_ITEM_SUCCESS";

export const UPDATE_TARIFIED_ITEM_START = "UPDATE_TARIFIED_ITEM_START";
export const UPDATE_TARIFIED_ITEM_ERROR = "UPDATE_TARIFIED_ITEM_ERROR";
export const UPDATE_TARIFIED_ITEM_SUCCESS = "UPDATE_TARIFIED_ITEM_SUCCESS";

export const TARIFICATION_SESSION_DELETE_START =
  "TARIFICATION_SESSION_DELETE_START";
export const TARIFICATION_SESSION_DELETE_SUCCESS =
  "TARIFICATION_SESSION_DELETE_SUCCESS";
export const TARIFICATION_SESSION_DELETE_ERROR =
  "TARIFICATION_SESSION_DELETE_ERROR";

export const FINISH_TARIFICATION_SESSION_START =
  "FINISH_TARIFICATION_SESSION_START";
export const FINISH_TARIFICATION_SESSION_ERROR =
  "FINISH_TARIFICATION_SESSION_ERROR";
export const FINISH_TARIFICATION_SESSION_SUCCESS =
  "FINISH_TARIFICATION_SESSION_SUCCESS";

/** ---- Dispatch Interfaces ---- */
interface TarificationUpdateTarifiedItemStart {
  type: typeof UPDATE_TARIFIED_ITEM_START;
}
interface TarificationUpdateTarifiedItemSuccess {
  type: typeof UPDATE_TARIFIED_ITEM_SUCCESS;
  payload: TarificationSessionKey;
}

interface TarificationUpdateTarifiedItemError {
  type: typeof UPDATE_TARIFIED_ITEM_ERROR;
}

interface TarificationSessionDeleteSuccess {
  type: typeof TARIFICATION_SESSION_DELETE_SUCCESS;
}

interface TarificationSessionDeleteError {
  type: typeof TARIFICATION_SESSION_DELETE_ERROR;
}

interface TarificationSessionDeleteStart {
  type: typeof TARIFICATION_SESSION_DELETE_START;
}

interface DeleteTarifiedStart {
  type: typeof DELETE_TARIFIED_ITEM_START;
}

interface DeleteTarifiedError {
  type: typeof DELETE_TARIFIED_ITEM_ERROR;
}

interface DeleteTarifiedSuccess {
  type: typeof DELETE_TARIFIED_ITEM_SUCCESS;
  payload: string;
}

interface TarificationSessionAppStart {
  type: typeof TARIFICATION_SESSION_APP_START;
}
interface TarificationSessionAppError {
  type: typeof TARIFICATION_SESSION_APP_ERROR;
}

interface TarificationSessionAppSuccess {
  type: typeof TARIFICATION_SESSION_APP_SUCCESS;
  payload: TarificationApplicationSession;
}

interface TarificationETarStart {
  type: typeof TARIFICATION_ETAR_START;
}
interface TarificationETarError {
  type: typeof TARIFICATION_ETAR_ERROR;
}

interface TarificationETarSuccess {
  type: typeof TARIFICATION_ETAR_SUCCESS;
  payload: ETarResult;
}

interface TarificationSessionStart {
  type: typeof TARIFICATION_SESSION_START;
}
interface TarificationSessionError {
  type: typeof TARIFICATION_SESSION_ERROR;
}

interface TarificationSessionSuccess {
  type: typeof TARIFICATION_SESSION_SUCCESS;
  payload: TarificationSessionKey;
}

interface TarificationSessionDetailsSuccess {
  type: typeof TARIFICATION_SESSION_DETAILS_SUCCESS;
  payload: TarificationSessionKey;
}

interface SetInsurabilityType {
  type: typeof LOAD_INSURABILITY_SUCCESS;
  payload: Insurability;
}

interface FinishTarificationSessionStart {
  type: typeof FINISH_TARIFICATION_SESSION_START;
}

interface FinishTarificationSessionSuccess {
  type: typeof FINISH_TARIFICATION_SESSION_SUCCESS;
}

interface FinishTarificationSessionError {
  type: typeof FINISH_TARIFICATION_SESSION_ERROR;
  payload: any;
}

export type CreateTarificationSessionType = (
  session: TarificationApplicationSession,
  userId: number,
  patientId: number,
  attestation: Attestation,
  history: History,
  tSession?: TarificationSessionKey
) => void;

export type DeleteOptionalTarificationSessionType = (
  session: TarificationApplicationSession,
  userId: number,
  patientId: number,
  tSession?: TarificationSessionKey
) => void;

export type DeleteTarifiedItemActionType = (
  session: TarificationApplicationSession,
  userId: number,
  sessionId: string,
  tarifiedItemId: string,
  history: History
) => void;

export type TarificationAction =
  | TarificationUpdateTarifiedItemStart
  | TarificationUpdateTarifiedItemSuccess
  | TarificationUpdateTarifiedItemError
  | TarificationSessionDeleteSuccess
  | TarificationSessionDeleteError
  | TarificationSessionDeleteStart
  | SetInsurabilityType
  | TarificationETarStart
  | TarificationETarError
  | TarificationETarSuccess
  | DeleteTarifiedStart
  | DeleteTarifiedError
  | DeleteTarifiedSuccess
  | TarificationSessionStart
  | TarificationSessionSuccess
  | TarificationSessionDetailsSuccess
  | TarificationSessionError
  | TarificationSessionAppStart
  | TarificationSessionAppSuccess
  | TarificationSessionAppError
  | SetInsurabilityType
  | FinishTarificationSessionStart
  | FinishTarificationSessionSuccess
  | FinishTarificationSessionError;
